<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-blue">
          <graph-tool-bar granularity="day" @on-selected="onPanelSelect"></graph-tool-bar>
        </md-card-header>

        <md-card-content>
          <highcharts class="charts" :options="chartOptions" ref="areaChart"></highcharts>
        </md-card-content>
      </md-card>
    </div>

    <snack-bar ref="snackbar"></snack-bar>
  </div>
</template>


<script>
import graphToolBar from "@/components/GraphToolBar";
import areaChartOptions from "@/config/charts/area";
import axios from "axios";
import { getSelectedDeviceToken } from "@/storage/memoryStorage";
import snackBar from "@/components/SnackBar";

export default {
  components: {
    "graph-tool-bar": graphToolBar,
    "snack-bar": snackBar
  },
  data() {
    return {
      chartOptions: null
    };
  },
  created() {
    this.chartOptions = JSON.parse(JSON.stringify(areaChartOptions));
    this.chartOptions.title.text = this.$lang.charts.energy_import;
    this.chartOptions.yAxis.labels.format = "{value} kWh";
    this.chartOptions.tooltip.pointFormat =
      "<span style='color:{point.color}'>●</span> {series.name}: <b>{point.y} kWh</b><br/>";

    this.chartOptions.series = [];

    this.chartOptions.yAxis.type = "logarithmic";
    this.chartOptions.chart.events = {
      redraw: function(event) {
        this.hideLoading();
      }
    };
  },

  methods: {
    onPanelSelect(data) {
      this.$nextTick(() => {
        this.getAPIData(data);
      });
    },

    getRelayNames(selected) {
      return axios({
        method: "POST",
        url: this.$ENDPOINTS.API_R + "/disconnector/settings",
        data: {
          token: getSelectedDeviceToken(selected.device.mac),
          names: true
        },
        withCredentials: true
      })
        .then(response => {
          return response.data.data;
        })
        .catch(error => {
          if (error.response) {
            if (error.response.data.code == 610) {
              return {
                R1: {
                  name: this.$lang.charts.relay + " 1"
                },
                R2: {
                  name: this.$lang.charts.relay + " 2"
                },
                R3: {
                  name: this.$lang.charts.relay + " 3"
                },
                R4: {
                  name: this.$lang.charts.relay + " 4"
                }
              };
            } else {
              this.$refs.snackbar.notify(
                this.$lang.messages.api_communication_error
              );
            }
          }
        });
    },

    getAPIData(selected) {
      const { chart } = this.$refs.areaChart;
      chart.showLoading();

      while (chart.series.length > 0) {
        chart.series[0].remove(false, false);
      }

      this.getRelayNames(selected).then(relaysName => {
        axios({
          method: "POST",
          url: this.$ENDPOINTS.API_R + "/disconnector/profile",
          data: {
            token: getSelectedDeviceToken(selected.device.mac),
          from: selected.date.from,
          to: selected.date.to,
            format: "H"
          },
          withCredentials: true
        })
          .then(response => {
            Object.keys(response.data.data).forEach((relay, index) => {
              chart.addSeries({
                name: relaysName[relay].name,
                type: "area",
                visible: true,
                marker: {
                  enabled: false
                },
                data: []
              });
              chart.series[index].setData(
                response.data.data[relay],
                false,
                false,
                false
              );
            });

            chart.xAxis[0].setExtremes(null, null, true);
          })
          .catch(error => {
            if (error.response) {
              if (error.response.data.code == 610) {
                this.$refs.snackbar.notify(this.$lang.messages.data_not_found);
                chart.series[0].setData([], false, false, false);
                chart.series[1].setData([], false, false, false);
                chart.series[2].setData([], false, false, false);
                chart.series[3].setData([], false, false, false);

                chart.xAxis[0].setExtremes(null, null, true);
              } else {
                this.$refs.snackbar.notify(
                  this.$lang.messages.api_communication_error
                );
              }
            }
          });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.md-layout {
  margin-top: -29px;
}
</style>